import React from 'react'
import { useTheme } from '@mui/material'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const StatusTimelineCurrent: React.FC<IconProps> = ({ size = ICON_SIZE.tiny, viewBox = ICON_VIEWBOX.tiny }) => {
  const { palette } = useTheme()

  return (
    <SvgWrapper aria-label="Status Timeline Current" size={size} viewBox={viewBox}>
      <circle cx="6" cy="6" r="5.5" fill={palette.primary.light} stroke={palette.primary.main} />
      <circle cx="6" cy="6" r="3" fill={palette.primary.main} />
    </SvgWrapper>
  )
}

export default StatusTimelineCurrent
